module.exports = __webpack_public_path__ + "media/images/menu-settings-active-icon-63abf273dd892a98fb1ad09e404cc5a4.svg";